import React from 'react';
import { useIntl } from 'react-intl';
import classnames from 'classnames';
import { PaymentMethod, SimplePicker, StoredPaymentMethodSelect, BillingInfo } from '@shipstation/financial-services-ui-components';

import { Text, TextType } from 'ui-components/components/text';
import { FlexColumn, FlexRow } from 'ui-components/components/flex';

import { emptyArray } from 'ui-components/default-props/empty';
import { TaxIdentifierSection } from '../../pages/settings/payment-and-subscription/components/tax-identifier-section';
import { PickerTitle } from '../picker-title';
import { useLocale } from '../../intl/hooks';
import { PaymentMethod as PaymentMethodStation } from '../../enums/payment-method';
import { usePaymentUpdateContext } from './';

import { messages } from '../messages';
import fsuiStyles from '../fsui-styles.module.less';
import style from './style.module.less';

const payByBankTypes = [PaymentMethod.PayByBankEU, PaymentMethod.PayByBankUS];

export const PaymentUpdateBody = ({ transactionCategory }) => {
  const locale = useLocale();
  const intl = useIntl();
  const {
    paymentType,
    paymentMethods,
    isAddingNew,
    preloadedSession,
    isBillingInfoLoading,
    selectedPaymentMethod,
    handlePaymentMethodChange,
    handleClickOnSwitchMode,
    setPaymentType,
    creditCardConfig,
    payByBankUsConfig,
    currencyCode,
    handleSetPerformFormValidation,
  } = usePaymentUpdateContext();

  const showBillingInfo =
    (isAddingNew && !payByBankTypes.includes(paymentType)) ||
    (!isAddingNew && selectedPaymentMethod?.paymentMethod !== PaymentMethodStation.ACH);

  const hasPaymentMethods = paymentMethods?.length > 0;

  return (
    <FlexRow className={style.container}>
      <FlexColumn className={style.left}>
        <Text className={style.title} textType={TextType.H2} value={messages.paymentUpdateTitle} />
        <PickerTitle
          className={classnames(style['picker-header-title'], {
            [style['handle-padding']]: isAddingNew,
          })}
          hasPaymentMethodsToPick={hasPaymentMethods}
          isAdding={isAddingNew}
          onClick={handleClickOnSwitchMode}
        />
        {isAddingNew ? (
          <SimplePicker
            acceptedPaymentTypes={preloadedSession?.eligiblePaymentMethodTypes || emptyArray}
            creditCardConfig={creditCardConfig}
            currencyCode={currencyCode}
            locale={locale}
            onPaymentTypeChange={setPaymentType}
            payByBankConfig={payByBankUsConfig}
            showTitle={false}
          />
        ) : (
          <StoredPaymentMethodSelect
            className={hasPaymentMethods ? fsuiStyles.picker : fsuiStyles['picker-no-content']}
            disabled={!hasPaymentMethods}
            emptyStateMessage={intl.formatMessage(messages.noPaymentMethodsAvailable)}
            hasError={false}
            initialValue={selectedPaymentMethod}
            isFullWidth
            isLoading={isBillingInfoLoading}
            name='paymentMethodSelect'
            onChange={handlePaymentMethodChange}
            paymentMethods={paymentMethods}
            placeholder={intl.formatMessage(messages.selectPaymentMethodPlaceholder)}
            transactionCategory={transactionCategory}
          />
        )}
        <TaxIdentifierSection />
      </FlexColumn>
      <FlexColumn className={style.right}>
        {showBillingInfo && (
          <div className={fsuiStyles['billing-info-wrapper']}>
            <BillingInfo
              key={`${selectedPaymentMethod?.id ?? preloadedSession?.id}-${isAddingNew}`}
              setPerformFormValidation={handleSetPerformFormValidation}
            />
          </div>
        )}
      </FlexColumn>
    </FlexRow>
  );
};
